module.exports = __webpack_public_path__ + "img/explode.21546930.png";